var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('clients-debt-table',{attrs:{"clients-debt-list":_vm.clientDebtList,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }